/* eslint-disable no-unused-vars */
import React from 'react'

export default function Support() {
  return (
    <div>Support</div>
  )
}
